import React, { useState, useRef } from "react";

// Modules

// App

// UI components
import { Col, Container, Row } from "react-bootstrap";
import {
  Alert,
  Button,
  Dialog,
  DialogContent,
  Stack,
  Typography,
  Snackbar,
  TextField,
  IconButton,
  Box,
} from "@mui/material";
import { ContentCopy, Share as ShareIcon } from "@mui/icons-material";
import DialogPaper from "./dialogPaper";

export default function ShareBtn(props) {
  const [modalVisible, setModalVisible] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const textAreaRef = useRef(null);
  const isBlog = window.location.pathname.includes("/blogs");
  const isFeatured = props.mode === "featured";

  let path = isBlog
    ? `${window.location.origin}/${props.route}/${props.id}`
    : `${window.location.origin}/${props.route}/view/${props.id}?hash=${props.field_access_token}`;

  const copyToClipboard = (string) => {
    navigator.clipboard.writeText(string);
    setSnackOpen(true);
  };

  const shareContent = () => {
    return (
      <Row>
        <Col xs={12}>
          <Typography className="mb-3">
            {props.sharePrompt ||
              `This is a public link that enables you to share this item with your client, no login required.`}
          </Typography>
        </Col>
        <Col xs={11}>
          <div className="form-group">
            <TextField
              ref={textAreaRef}
              id="presentation-link"
              multiline
              maxRows={4}
              value={path}
              sx={{
                width: "100%",
              }}
            />
          </div>
        </Col>
        <Col xs={1}>
          <IconButton
            sx={{ float: "right" }}
            aria-label="copy"
            onClick={(event) => {
              copyToClipboard(path);

              event?.stopPropagation();
              event?.preventDefault();
            }}
          >
            <ContentCopy />
          </IconButton>
        </Col>
      </Row>
    );
  };

  const renderIcon = () => {
    return (
      <ShareIcon
        sx={{
          fontSize: props.listItem
            ? "1.2rem"
            : isFeatured
            ? "0.8rem"
            : "0.8rem",
          padding: isFeatured ? "2px" : "0",
        }}
      />
    );
  };

  return (
    <>
      <Col
        xs={props.xs ? props.xs : "auto"}
        className={`${props.className ? props.className : "ps-0"} d-flex`}
      >
        <Button
          className={isFeatured ? "me-0" : ""}
          variant={
            props.enableLabel
              ? "singleScreenBtn"
              : props.listItem
              ? "listItemBtn"
              : "screenItemBtn"
          }
          owner={props.owner ?? "client"}
          mode={isFeatured ? "featured" : "default"}
          disableRipple={!isFeatured}
          {...(props.enableLabel && { endIcon: renderIcon() })}
          onClick={(event) => {
            event?.stopPropagation();
            event?.preventDefault();
            setModalVisible(true);
          }}
        >
          {props.enableLabel ? "Share" : renderIcon()}
        </Button>
      </Col>

      <Dialog
        open={modalVisible}
        onClose={(event) => {
          event?.stopPropagation();
          event?.preventDefault();

          setModalVisible(false);
        }}
        className="ps-modal share-modal"
        maxWidth="lg"
        fullWidth={true}
        PaperComponent={DialogPaper}
      >
        <Box className="ps-modal-title dialog-draggable-handle">
          <Container fluid>
            <Row className="align-items-center">
              <Col xs={12} sm={6} md={10}>
                <Typography variant="h3" owner="admin" color="adminText.dark">
                  {`Sharing (${props.title ? props.title : props.id})`}
                </Typography>
              </Col>
              <Col xs={12} sm={6} md={2}>
                <Stack
                  direction="row"
                  justifyContent="flex-end"
                  alignItems="center"
                  spacing={1}
                >
                  <Button
                    variant="outlined"
                    owner="admin"
                    dialogbtn="true"
                    dialogvariant="cancel"
                    className="lh"
                    onClick={(event) => {
                      event?.stopPropagation();
                      event?.preventDefault();
                      setModalVisible(false);
                    }}
                  >
                    <Typography variant="button" owner="admin" className="lh">
                      Close
                    </Typography>
                  </Button>
                </Stack>
              </Col>
            </Row>
          </Container>
        </Box>

        <DialogContent>
          <Box className="ps-modal-content">
            <Container fluid>
              <Row className="ps-relative">
                <Col>{shareContent()}</Col>
              </Row>
            </Container>
          </Box>
        </DialogContent>

        <Snackbar
          open={snackOpen}
          autoHideDuration={3000}
          onClose={(event) => {
            setSnackOpen(false);
            event?.stopPropagation();
            event?.preventDefault();
          }}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={(event) => {
              setSnackOpen(false);
              event?.stopPropagation();
              event?.preventDefault();
            }}
            severity="success"
            sx={{ width: "100%" }}
          >
            Link copied!
          </Alert>
        </Snackbar>
      </Dialog>
    </>
  );
}
